import { Record } from 'immutable';
import { BrandingTypes, Customer } from 'services/resources';
import { PublicDealershipSettings } from './types';

export const CustomerRecordFactory = Record<Customer>({
  id: null,
  dmsId: null,
  firstName: null,
  lastName: null,
  email: null,
  sex: null,
  address1: null,
  address2: null,
  postalCode: null,
  city: null,
  state: null,
  country: null,
  businessName: null,
  licenseFront: null,
  licenseBack: null,
  licenseNumber: null,
  licenseExpires: null,
  licenseState: null,
  phoneCell: null,
  phoneBusiness: null,
  phoneResidential: null,
  dateOfBirth: null,
  language: null,
  notificationPreference: null,
  insuranceFront: null,
  insuranceBack: null,
  insuranceProvince: null,
  insurancePolicyExpiry: null,
  insurancePolicyNumber: null,
  insuranceCompanyName: null,
  note: null,
  created: null,
  modified: null,
  createdInFleet: false,
  defaultCreditcard: null,
  dealership: null,
});

export const DealershipSettingsRecordFactory = Record<PublicDealershipSettings>({
  brandingType: BrandingTypes.FLEETLANE,
  latitude: null,
  longitude: null,
});

export interface PublicState {
  customer: Record<Customer> | null;
  dealershipSettings: Record<PublicDealershipSettings> | null;
}

export const PublicStateFactory = Record<PublicState>({
  customer: null,
  dealershipSettings: null,
});
